import { X } from "lucide-react";
import React from "react";

export const MyModal = ({
  isOpen,
  onClose,
  title,
  children,
  width = "450px",
  icon,
}) => {
  if (!isOpen) return null;
  const Icon = icon ?? null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/30  z-50
    backdrop-blur-sm
    "
    >
      <div
        className="relative p-4 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl  border border-state-200/50 dark:border-slate-700/50  space-x-2"
        style={{ width }}
      >
        <div className="flex items-center space-x-2">
          {Icon && <Icon className="w-5 h-5 dark:text-white text-slate-800" />}
          <h1 className="text-md font-semibold text-black-600 dark:text-slate-200 ">
            {title}
          </h1>
          {/* Close button */}
          {onClose && (
            <X
              onClick={onClose}
              className="w-6 h-6 p-1 absolute top-4 right-4 
          text-slate-800 dark:text-slate-300 
          bg-slate-400/30 dark:bg-slate-700 
          hover:bg-slate-400/50 dark:hover:bg-slate-700/30
          hover:shadow-lg hover:shadow-slate-900/20
          transition-all duration-300 group
          rounded-full"
            />
          )}
        </div>
        {children}
      </div>
    </div>
  );
};
